import React from "react";
import classes from "./style.module.scss";

const stepsArray = [
  {
    step: 1,
    name: "step1",
  },
  {
    activeIndex: 2,
    name: "bar",
  },
  {
    step: 2,
    name: "step2",
  },
  {
    activeIndex: 3,
    name: "bar",
  },
  {
    step: 3,
    name: "step3",
  },
  {
    activeIndex: 4,
    name: "bar",
  },
  {
    step: 4,
    name: "step4",
  },
  {
    activeIndex: 5,
    name: "bar",
  },
  {
    step: 5,
    name: "step5",
  },
];

const loansArray = [
  {
    step: 1,
    name: "RM Approval",
  },
  {
    activeIndex: 2,
    name: "bar",
  },
  {
    step: 2,
    name: "FC Review",
  },
  {
    activeIndex: 3,
    name: "bar",
  },
   {
    step: 3,
    name: "Disburse",
  },
  {
    activeIndex: 4,
    name: "step3",
  },
]

const Steps = ({ stepCount, currentStep, isLoansArray = false }) => {
  return (
    <div>

      {!isLoansArray ? (
        <div className="flex items-center justify-center fs-14">
          {stepsArray.map((element, index) => {
            if (element.name !== "bar" && element.step <= stepCount) {
              const isCompleted = element.step < currentStep;

              return (
                <div
                  key={element.step + index}
                  className={`${classes.stepCnt} ${isCompleted ? classes.completed : ''}`}
                  data-selected={element.step === currentStep}
                >
                  {isCompleted && (
                    <span className={classes.checkMarkIcon}>✔</span>
                  )}
                  {element.name}
                </div>
              );
            }

            if (element.name === "bar" && element.activeIndex <= stepCount) {
              const isBarActive = stepsArray[index - 1]?.step < currentStep;

              return (
                <div
                  key={`bar-${index}`}
                  className={`${classes.stepProgressBar} ${isBarActive ? classes.active : ''}`}
                />
              );
            }

            return null;
          })}
        </div>

      ) : (
        <div className="flex items-center justify-center fs-14">
          {loansArray.map((element, index) => {
            if (element.name !== "bar" && element.step <= stepCount) {
              const isCompleted = element.step < currentStep;

              return (
                <div
                  key={element.step + index}
                  className={`${classes.stepCnt} ${isCompleted ? classes.completed : ''}`}
                  data-selected={element.step === currentStep}
                >
                  {isCompleted && (
                    <span className={classes.checkMarkIcon}>✔</span>
                  )}
                  {element.name}
                </div>
              );
            }

            if (element.name === "bar" && element.activeIndex <= stepCount) {
              const isBarActive = stepsArray[index - 1]?.step < currentStep;

              return (
                <div
                  key={`bar-${index}`}
                  className={`${classes.stepProgressBar} ${isBarActive ? classes.active : ''}`}
                />
              );
            }

            return null;
          })}
        </div>

      )}
    </div>
  );
};

export default Steps;
